export default __webpack_public_path__ + "static/logo-Navbar-ad5f22f6d212ad484b2a5c39eb95e9b7.png";